import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vers: {},
};

export const versSlice = createSlice({
  name: "vers",
  initialState,

  reducers: {
    setVersData: (state, action) => {
      const {
        item,
        value,
        type = "VERS",
        dateVers,
        date,
      } = action.payload || {};
      if (!item) return;
      if (Array.isArray(state.vers)) state.vers = {}; // 🛡️
      state.vers[item] = { item, value, type, dateVers, date };
    },

    setVersSent: (state, action) => {
      state.cuveSent = action.payload;
    },

    clearVers: (state) => {
      state.vers = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setVersData, clearVers, setVersSent } = versSlice.actions;

export default versSlice.reducer;
